import { render, staticRenderFns } from "./CProcessRatingList.vue?vue&type=template&id=bffa051c&"
import script from "./CProcessRatingList.vue?vue&type=script&lang=js&"
export * from "./CProcessRatingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports